import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectAdminPermission = (state: ApplicationRootState) =>
    state.admin.permission || initialState;

export const selectPermissionList = createSelector(
    selectAdminPermission,
    (state) => state.list
);
